
export default function WhyJaws() {
  const features = [
    {
      icon: 'ri-moon-line',
      title: 'Better Sleep Quality',
      description: 'Encourages nasal breathing throughout the night for deeper, more restorative rest.'
    },
    {
      icon: 'ri-focus-3-line',
      title: 'Jawline Definition',
      description: 'Supports proper jaw positioning to help maintain and enhance facial structure over time.'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Improved Breathing',
      description: 'Trains your body to breathe through your nose, reducing snoring and improving oxygen intake.'
    }
  ];

  return (
    <section id="how-it-works" className="py-16 sm:py-24 lg:py-32 px-4 sm:px-6 lg:px-20 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16 lg:mb-20 max-w-3xl mx-auto">
          <div className="text-[10px] sm:text-xs uppercase tracking-[0.12em] sm:tracking-[0.15em] text-[#8A8A8A] mb-4 sm:mb-6">
            WHY CHOOSE US
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-black leading-tight mb-4 sm:mb-6 px-4">
            Small Habits, Big Results
          </h2>
          <p className="text-sm sm:text-base text-[#6B6B6B] leading-relaxed px-4">
            Consistency is the key to transformation. Our product works while you sleep, making improvement effortless.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-10">
          {features.map((feature, index) => (
            <div key={index} className="bg-white p-6 sm:p-8 rounded-2xl hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-black rounded-full flex items-center justify-center mb-4 sm:mb-6">
                <i className={`${feature.icon} text-xl sm:text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-semibold text-black mb-2 sm:mb-3">{feature.title}</h3>
              <p className="text-sm sm:text-base text-[#6B6B6B] leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
